import { createContext, useContext, type ReactNode } from 'react';
import type { GameState, Participant } from './types';

/** UUID fittizio: `useGameState` / `useActiveSessionId` lo riconoscono solo dentro il provider preview. */
export const LAYOUT_PREVIEW_SESSION_ID = 'aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa';

export type LayoutPreviewVotePhase = 'not_open' | 'active' | 'voted' | 'closed';

export interface LayoutPreviewValue {
  state: GameState | null;
  participants: Participant[];
  /** Solo per `/dev/layout/vote/*`: quale schermata del flusso voto simulare. */
  votePhase?: LayoutPreviewVotePhase;
}

const LayoutPreviewContext = createContext<LayoutPreviewValue | null>(null);

export function useLayoutPreview(): LayoutPreviewValue | null {
  return useContext(LayoutPreviewContext);
}

export function LayoutPreviewProvider({
  value,
  children,
}: {
  value: LayoutPreviewValue;
  children: ReactNode;
}) {
  return <LayoutPreviewContext.Provider value={value}>{children}</LayoutPreviewContext.Provider>;
}

/** Forza `useActiveSessionId` → null (stesso stato del maxi senza sessione regia). */
const DevMaxiNoSessionContext = createContext(false);

export function DevMaxiNoSessionProvider({ children }: { children: ReactNode }) {
  return <DevMaxiNoSessionContext.Provider value={true}>{children}</DevMaxiNoSessionContext.Provider>;
}

export function useDevMaxiNoSession(): boolean {
  return useContext(DevMaxiNoSessionContext);
}
